import React from 'react';
import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import AccordionOne from '../accordion/AccordionOne';
import ScrollAnimation from "react-animate-on-scroll";
import Accordion7 from '../accordion/Accordion7';
import { useTranslation } from 'react-i18next';

const About9 = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="rn-about-area about-style-3 rn-section-gap">
            <div className="container">
                <div className="row row--30">
                    <div className="col-lg-5">
                        <div className="thumbnail">
                            <img className="w-100" src="./images/about/信托.png" alt="About Images" />
                        </div>
                    </div>
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="inner">
                            <div className="section-title">
                                <h4 className="subtitle">
                                    <span className="theme-gradient">{t("127")} </span>
                                </h4>
                                <h2 className="title mb--40">{t("128")} </h2>
                            </div>
                            <Accordion7 customStyle="" />
                        </div>
                    </div>
                </div>
            </div>                        
        </div>
    )
}

export default About9